import { createRoot } from "react-dom/client";
import { StoreProvider } from "../app/storeProvider";
import React from "react";
import SubscriptionCheckout from "../app/(general-header)/subscription-checkout/page";

const root = createRoot(document.getElementById("subscription-checkout-container") as HTMLElement);

root.render(
  <React.StrictMode>
    <StoreProvider>
      <SubscriptionCheckout />
    </StoreProvider>
  </React.StrictMode>
);
